/**
 * Скелетон таблицы (§2.3, §11.1).
 *
 * 12 строк по 28 px, в каждой — прямоугольники 60 % ширины колонки. Без
 * анимации: переливы на 2 vCPU дороже, чем честная статичная полоса.
 *
 * Для скринридера блок — `role="status"` с подписью: иначе загрузка среза
 * выглядит как пустая таблица.
 */
import './Skeleton.css'

export interface SkeletonProps {
  /** Сколько строк рисовать. По умолчанию 12 (§2.3). */
  rows?: number
  /**
   * Ширины колонок в px — те же, что у реальной таблицы (§4.2).
   * Полоса внутри колонки занимает 60 % её ширины.
   */
  columns?: number[]
  /** Высота строки: бренд 28 px или категория 26 px. */
  rowHeight?: 'brand' | 'cat'
  /** Подпись для скринридера. */
  label?: string
  className?: string
}

/** Доля ширины колонки, которую занимает полоса (§2.3). */
const BAR_RATIO = 0.6

const DEFAULT_COLUMNS = [212, 48, 36, 44, 200, 140, 120, 80, 96]

export function Skeleton({
  rows = 12,
  columns = DEFAULT_COLUMNS,
  rowHeight = 'brand',
  label = 'Загружаем бренды',
  className,
}: SkeletonProps) {
  const classes = ['skeleton']
  if (className) classes.push(className)

  return (
    <div className={classes.join(' ')} role="status" aria-label={label} aria-busy="true">
      {Array.from({ length: rows }, (_, rowIndex) => (
        <div
          key={rowIndex}
          className={rowHeight === 'cat' ? 'skeleton__row skeleton__row--cat' : 'skeleton__row'}
        >
          {columns.map((width, columnIndex) => (
            <span
              key={columnIndex}
              className="skeleton__bar"
              style={{ width: `${Math.round(width * BAR_RATIO)}px` }}
            />
          ))}
        </div>
      ))}
    </div>
  )
}
